/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CompassIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5UlEQVR4nMVVzUrDQBD2pt6sJ6niM4gv4DU22ZnNIZ1pPcT6ECKKgvo82oIVn0FFPVrx1go9qiioJ2VSsZtk06QedCEQwuabne9ndmLiP1cQBLOgeQOQW0pzBzS9yvP93gSoNly3XvoN8DRo2gFNz6D5c9SjkJ8U0rb8UwgcgMuAfJEHDMlCmm48L1gcCe77awug+WFccPjphnquG8xn04J89VtwGHZyuRKGU2lqIs4LAiH3FVJbIe+DX2Wl6TS+h7aSp58dIeg7IJ2B5gOlCW0UgE9BUviYuyIrWk9Kb4j1pTxjRJ2k9VgfFkBuZYjWzgMfFKC2RYtjs4N7Oz20N6SBXXGYOMXTtBqjCLmfLsAds8UXWwHEWsU4Zc/4uZuwti2AL7kFKkEwl1fAw5rO6P7ZLHBnC41Jg9Ai3wRc+ewYhQ8zDHJraEBNi9dbRQT+trAtK0fDTVBtWDrYzQP3/OqyQv6wJ5rDWNAkHOYG4TYJKJoM3ER7gHwShdA+Lh4Rw5nYzzJykz6W5Eon0X1giJw7j5A3U+3KgJJBVXge6cyJem4ddrJkzoxzUkjz3pX7ZLQrgMtyivHB6Tr3wjHpkpGbFD5LUOHccZzJQuBxyuolmYpRTpBuJfFR6uU9MgGHKbf89foC5+d8SRIYQ6AAAAAASUVORK5CYII=)
 */
export const CompassIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M23 12a11 11 0 1 1-22 0 11 11 0 0 1 22 0ZM7.74 9.3A2 2 0 0 1 9.3 7.75l7.22-1.45a1 1 0 0 1 1.18 1.18l-1.45 7.22a2 2 0 0 1-1.57 1.57l-7.22 1.45a1 1 0 0 1-1.18-1.18L7.74 9.3Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
